module.exports = __webpack_public_path__ + "static/media/chat-send-button.bb8baa17.svg";